import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NoSearchResultIcon from '../../assets/NoSearchResultIcon';

const NoPermission: React.FC = () => {

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        marginTop: 30,
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant="h3" fontWeight='700' data-testid="no-permission-message">
          You do not have permission to access.
        </Typography>

        <Box pt={5}>
          <NoSearchResultIcon
            sx={{
              width: '100%',
              maxWidth: '100vw',
              height: 'auto',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default NoPermission;
